// extracted by mini-css-extract-plugin
module.exports = {"card-sand":"key-takeaways_card-sand__JZgL2","card-sand-title":"key-takeaways_card-sand-title__cCUcG"};